var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4651 8.32558C14.4651 7.06735 13.9653 5.86064 13.0756 4.97094C12.1859 4.08123 10.9792 3.5814 9.72093 3.5814C8.46269 3.5814 7.25599 4.08123 6.36628 4.97094C5.47658 5.86064 4.97674 7.06735 4.97674 8.32558V14.6512H14.4651V8.32558ZM16.0465 15.1786L16.3628 15.6C16.4068 15.6587 16.4337 15.7286 16.4403 15.8017C16.4469 15.8748 16.433 15.9483 16.4001 16.014C16.3673 16.0797 16.3168 16.1349 16.2544 16.1735C16.1919 16.2121 16.1199 16.2326 16.0465 16.2326H3.39535C3.32193 16.2326 3.24996 16.2121 3.1875 16.1735C3.12505 16.1349 3.07457 16.0797 3.04174 16.014C3.0089 15.9483 2.995 15.8748 3.0016 15.8017C3.00819 15.7286 3.03502 15.6587 3.07907 15.6L3.39535 15.1786V8.32558C3.39535 6.64793 4.06179 5.039 5.24807 3.85272C6.43435 2.66644 8.04328 2 9.72093 2C11.3986 2 13.0075 2.66644 14.1938 3.85272C15.3801 5.039 16.0465 6.64793 16.0465 8.32558V15.1786ZM7.74419 17.0233H11.6977C11.6977 17.5475 11.4894 18.0503 11.1187 18.421C10.748 18.7917 10.2452 19 9.72093 19C9.19666 19 8.69387 18.7917 8.32316 18.421C7.95245 18.0503 7.74419 17.5475 7.74419 17.0233Z",
    fill: "#225DA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferIcon);
export default __webpack_public_path__ + "static/media/refer-icon.f7f0a8207350a84ab2f1ec4eb4d8818b.svg";
export { ForwardRef as ReactComponent };